import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section id="studio" className="relative min-h-screen flex flex-col justify-center pt-32 pb-20 px-6 md:px-12 overflow-hidden" data-id="element-95">
      <div className="max-w-7xl mx-auto w-full" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end" data-id="element-97">
          <div className="lg:col-span-9" data-id="element-98">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-99">
              <h1 className="text-5xl md:text-7xl lg:text-[7.5rem] leading-[1.05] font-serif text-balance" data-id="element-100">
                We build the <br className="hidden md:block" data-id="element-101" />
                <span className="text-orange italic pr-4" data-id="element-102">ideas</span> we want
                to <br className="hidden md:block" data-id="element-103" />
                see in the world.
              </h1>
            </motion.div>
          </div>

          <div className="lg:col-span-3 pb-4" data-id="element-104">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 0.4
          }} className="flex flex-col gap-6" data-id="element-105">
              <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-light" data-id="element-106">
                LaunchCave is an independent product studio and incubator. We
                ideate, build, and scale software products from the ground up.
              </p>
              <div className="pt-4" data-id="element-107">
                <a href="#approach" className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-navy/20 hover:border-orange hover:text-orange transition-colors duration-300" data-id="element-108">
                  <ArrowDown className="w-5 h-5" data-id="element-109" />
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-1/4 right-0 w-[800px] h-[800px] bg-orange/5 rounded-full blur-3xl -z-10 pointer-events-none translate-x-1/3" data-id="element-110" />
    </section>;
}